<template>
  <div>
    <div class="container" style="width:100%">

      <div v-if="etape==1" style="text-align:justify;margin:10px 20px;" v-html="$t('description_rapide_outil')">
      </div>
      <div v-if="etape==1" style="text-align:justify;margin:10px 20px;border:1px solid #cc0000;padding:5px;" v-html="$t('attention')">
      </div>

      <div style="width:130px;margin:auto; margin-top:30px">
          <button v-bind:class="{ active: etape==1, etape }" v-on:click="setEtape(1)">1</button>
          <button v-bind:class="{ active: etape==2, etape }" v-on:click="setEtape(2)">2</button>
          <button v-bind:class="{ active: etape==3, etape }" v-on:click="setEtape(3)" :disabled="this.errors_nb.length > 0">3</button>
      </div>

      <div id="etape1" v-if="etape==1">
        <div class="titre-section">{{ $t('titre_section1') }}</div>

        <div class="saisie">
          <div class="ligne-saisie">
            <label>{{ $t('libelle_periode_impantation') }} :</label>
            <select class="liste-deroulante zone-choix" v-model="liste_periodes_implantation" v-on:change="AgronomicalAdvice">
              <option v-for="sowing_period of sowing_periods" v-bind:key="'SP'+sowing_period.txt_id" :value="{ id: sowing_period.txt_id, name: sowing_period.name }">
                {{sowing_period.name}}
              </option>
            </select>
          </div>

          <div class="ligne-saisie">
            <label>{{ $t('libelle_produit_organique') }} :</label>
            <select class="liste-deroulante zone-choix" v-model="liste_produits_organiques" v-on:change="RetrieveContent">
              <option v-for="organic_fertiliser of organic_fertilisers" v-bind:key="'OF'+organic_fertiliser.id" :value="{ id: organic_fertiliser.id, name: organic_fertiliser.name }">
                {{organic_fertiliser.name}}
              </option>
            </select>
          </div>

          <div v-if="liste_produits_organiques.id">
            <div class="ligne-saisie">
              <label>{{ $t('libelle_elements_fertilisants') }} : <img src="../assets/info2.jpg" style="width:20px;vertical-align:middle;" v-tooltip.right-start="{content: getTextTooltip('tooltip_elements_fertilisants'), trigger: 'hover click', classes: 'tooltip'}" :open-on-hover="true" /></label>
              <div class="zone-choix">
                <div class="ligne-element"><span class="nom-element">N<sub>{{ $t('N_total') }}</sub> : </span><number-input class="number-input" v-model="nutrient_content['Ntot']" :min="0" :max="500" placeholder="Ntot" size="small" inline controls></number-input><span> kg/T</span></div>
                <div class="ligne-element"><span class="nom-element">N<sub>{{ $t('N_mineral') }}</sub> : </span><number-input class="number-input" v-model="nutrient_content['N-NH4']" :min="0" :max="500" placeholder="Nmin" size="small" inline controls></number-input><span> kg/T</span></div>
                <div class="ligne-element"><span class="nom-element">P<sub>2</sub>O<sub>5</sub> : </span><number-input class="number-input" v-model="nutrient_content['P2O5']" :min="0" :max="500" placeholder="P2O5" size="small" inline controls></number-input><span> kg/T</span></div>
                <div class="ligne-element"><span class="nom-element">K<sub>2</sub>O : </span><number-input class="number-input" v-model="nutrient_content['K2O']" :min="0" :max="500" placeholder="K2O" size="small" inline controls></number-input><span> kg/T</span></div>
                <div class="ligne-element"><span class="nom-element">MgO : </span><number-input class="number-input" v-model="nutrient_content['MgO']" :min="0" :max="500" placeholder="MgO" size="small" inline controls></number-input><span> kg/T</span></div>
              </div>
            </div>

            <div class="ligne-saisie">
              <label>{{ $t('libelle_elements_carbone') }} : </label>
              <div class="zone-choix">
                <div class="ligne-element"><span class="nom-element">C<sub>org</sub> : </span><number-input class="number-input" v-model="nutrient_content['Corg']" :min="0" :max="500" placeholder="Corg" size="small" inline controls></number-input><span> kg/T</span></div>
              </div>
            </div>
          
            <div class="ligne-saisie">
              <label>{{ $t('libelle_periode_apport') }} :</label>
              <select class="liste-deroulante zone-choix" v-model="liste_periodes_apport" v-on:change="AgronomicalAdvice">
                <option v-for="feeding_period of feeding_periods" v-bind:key="'FP'+feeding_period.txt_id" :value="{ id: feeding_period.txt_id, name: feeding_period.name }">
                  {{feeding_period.name}}
                </option>
              </select>
            </div>

            <div class="ligne-saisie">
              <label>{{ $t('libelle_technique_epandage') }} :</label>
              <select class="liste-deroulante zone-choix" v-model="liste_techniques_epandage" v-on:change="Bilan">
                <option v-for="application_method of application_methods" v-bind:key="'AM'+application_method.txt_id" :value="{ id: application_method.txt_id, name: application_method.name }">
                  {{application_method.name}}
                </option>
              </select>
            </div>

          </div>
<!--v-if="this.liste_periodes_apport.id!=undefined && this.liste_techniques_epandage.id!=undefined && advice.advice_code"-->
          <div class="resultat-periode" v-if="this.liste_periodes_apport.id!=undefined && this.liste_techniques_epandage.id!=undefined && advice.advice_code">
            <img :src="getImgUrl('tete_'+advice.advice_code+'.jpg')" style="width:20px;vertical-align:middle;"/>
            {{ $t('phrase_conseil') }} <b><u>{{advice.advice_text}}</u></b>
            <img src="../assets/info2.jpg" style="width:20px;vertical-align:middle;margin-left:10px;" v-tooltip.right-start="{content: getTextTooltip('tooltip_advice'), trigger: 'hover click', classes: 'tooltip'}" :open-on-hover="true" />
          </div>

          <button class="btn-suivant" v-on:click="setEtape(2)">{{ $t('bouton_suivant') }}</button>
        </div>
  
      </div>

      <div id="etape2" v-if="etape==2">
        <div class="titre-section">{{ $t('titre_section2') }}</div>
        <div class="saisie">
          <div style="margin:30px 0px;">{{ $t('phrase_choix_engrais') }} : {{this.liste_produits_organiques.name}}</div>

          <div class="ligne-saisie">
            <label>{{ $t('libelle_dose_prevue') }} : </label>
            <div class="zone-choix">
                <div class="ligne-element"><number-input class="number-input" v-model="dose" id="dose" :min="0" :max="100" v-on:change="Bilan" placeholder="Small" size="small" inline controls></number-input><span> {{this.organic_fertiliser_unit}}/ha</span></div>
            </div>
          </div>

          <div v-if="errors_nb.length>0" style="color:#CC0000">
            {{ $t('erreurs.erreur_api_bilan') }}
            <p style="font-size:10px;">{{this.errors_nb[0]}}</p>
          </div>

          <div v-if="balance.P2O5 && errors_nb.length==0">
            <div class="ligne-saisie" style="margin-top:30px;">
              <div style="text-align: left;margin-bottom:10px;">
                {{ $t('effet_fertilisant') }} <img src="../assets/info2.jpg" style="width:20px;vertical-align:middle;float:left;" v-tooltip.right-start="{content: getTextTooltip('tooltip_N_eff'), trigger: 'hover click', classes: 'tooltip'}" :open-on-hover="true" /> :
              </div>
              <div style="margin-bottom:20px;">
                <div class="col1">
                  N<sub>{{ $t('N_efficace_cycle') }}</sub> : <b>{{balance.NtotGlobal.fertilising_effect}}</b> <span style="font-size:0.7em;">kg/ha</span>
                  <br>N<sub>{{ $t('N_efficace_bilan') }}</sub> : <b>{{balance.NtotBilan.fertilising_effect}}</b> <span style="font-size:0.7em;">kg/ha</span>
                </div>
                <div class="col2">P<sub>2</sub>O<sub>5</sub> : <b>{{balance.P2O5.fertilising_effect}}</b> <span style="font-size:0.7em;">kg/ha</span></div>
                <div class="col3">K<sub>2</sub>O : <b>{{balance.K2O.fertilising_effect}}</b> <span style="font-size:0.7em;">kg/ha</span></div>
                <div class="col4">MgO : <b>{{balance.MgO.fertilising_effect}}</b> <span style="font-size:0.7em;">kg/ha</span></div>
              </div>
            </div>

            <div class="categorie-deplie"> {{ $t('cadre_besoins_previ') }} <img :src="getImgUrl(boutonBesoins+'.png')" v-on:click="switchB('besoins')" style="width:20px;vertical-align:middle;margin-left:30px;"/>
            </div>
            <div class="ligne-saisie" v-if="boutonBesoins=='moins'">
              <img src="../assets/info2.jpg" style="width:20px;vertical-align:middle;float:left;" v-tooltip.right-start="{content: getTextTooltip('tooltip_besoins_previ'), trigger: 'hover click', classes: 'tooltip'}" :open-on-hover="true" />
              <div class="zone-choix-centre">
                <div class="ligne-element"><span class="nom-element">N : </span><number-input class="number-input" v-model="scheduled.N" :min="0" :max="500" placeholder="N" size="small" inline controls></number-input><span> kg/ha</span></div>
                <div class="ligne-element"><span class="nom-element">P<sub>2</sub>O<sub>5</sub> : </span><number-input class="number-input" v-model="scheduled.P2O5" :min="0" :max="500" placeholder="P2O5" size="small" inline controls></number-input><span> kg/ha</span></div>
                <div class="ligne-element"><span class="nom-element">K<sub>2</sub>O : </span><number-input class="number-input" v-model="scheduled.K2O" :min="0" :max="500" placeholder="K2O" size="small" inline controls></number-input><span> kg/ha</span></div>
                <div class="ligne-element"><span class="nom-element">MgO : </span><number-input class="number-input" v-model="scheduled.MgO" :min="0" :max="500" placeholder="MgO" size="small" inline controls></number-input><span> kg/ha</span></div>
              </div>
            </div>

            <div class="categorie-deplie"> {{ $t('cadre_apports_mineraux') }} <img :src="getImgUrl(boutonApportM+'.png')" v-on:click="switchB('apports')" style="width:20px;vertical-align:middle;margin-left:30px;"/>
            </div>
            <div class="ligne-saisie" v-if="boutonApportM=='moins'">
              <img src="../assets/info2.jpg" style="width:20px;vertical-align:middle;float:left;" v-tooltip.right-start="{content: getTextTooltip('tooltip_apports_mineraux'), trigger: 'hover click', classes: 'tooltip'}" :open-on-hover="true" />
              <div class="zone-choix-centre">
                <div class="ligne-element"><span class="nom-element">N<sub>{{ $t('N_total') }}</sub> : </span><number-input class="number-input" v-model="mineral.N" :min="0" :max="500" placeholder="N" size="small" inline controls></number-input><span> kg/ha</span></div>
                <div class="ligne-element"><span class="nom-element">P<sub>2</sub>O<sub>5</sub> : </span><number-input class="number-input" v-model="mineral.P2O5" :min="0" :max="500" placeholder="P2O5" size="small" inline controls></number-input><span> kg/ha</span></div>
                <div class="ligne-element"><span class="nom-element">K<sub>2</sub>O : </span><number-input class="number-input" v-model="mineral.K2O" :min="0" :max="500" placeholder="K2O" size="small" inline controls></number-input><span> kg/ha</span></div>
                <div class="ligne-element"><span class="nom-element">MgO : </span><number-input class="number-input" v-model="mineral.MgO" :min="0" :max="500" placeholder="MgO" size="small" inline controls></number-input><span> kg/ha</span></div>
              </div>
            </div>

          </div>
          <button class="btn-suivant" v-on:click="setEtape(3)" :disabled="this.errors_nb.length > 0">{{ $t('bouton_suivant') }}</button>
        </div>

      </div>

      <div id="etape3" v-if="etape==3">
        <div class="titre-section">{{ $t('titre_section3') }}</div>  

        <div class="saisie">
              <div style="margin:30px 0px;">{{ $t('phrase_choix_engrais') }} : {{this.liste_produits_organiques.name}}</div>
              
              <div style="text-align:left;margin-top:30px;">{{ $t('libelle_bilan') }} ({{dose}} {{this.organic_fertiliser_unit}}/ha) : <br>{{ $t('libelle_bilan_unite') }}</div>
              <div class="col1 lignegraph">
                <JqxGaugeN ref="GaugeN" :ranges="ranges" :ticksMinor="ticksMinor"
                :ticksMajor="ticksMajor" :value="balance.NtotBilan.nutrient_balance" :cap="cap" :pointer="pointer" :caption="caption"
                :colorScheme="'scheme05'" :animationDuration="1200" :min="min" :max="max" :labels="labels" :ticksDistance="ticksDistance"
                :radius="radius" :width="width" :height="height" :border="border" style="margin:auto">
                </JqxGaugeN>
                <div style="margin:3px;font-size:13px;">N : {{ balance.NtotBilan.conclusion_text }}</div>
              </div>
              <div class="col2 lignegraph">
                <JqxGaugeP2O5 ref="GaugeP2O5" :ranges="ranges" :ticksMinor="ticksMinor"
                :ticksMajor="ticksMajor" :value="balance.P2O5.nutrient_balance" :cap="cap" :pointer="pointer" :caption="caption"
                :colorScheme="'scheme05'" :animationDuration="1200" :min="min" :max="max" :labels="labels"
                :radius="radius" :width="width" :height="height" :border="border" style="margin:auto">
                </JqxGaugeP2O5>
                <div style="margin:3px;font-size:13px;">P<sub>2</sub>O<sub>5</sub> : {{ balance.P2O5.conclusion_text }}</div>
              </div>
              <div class="col3 lignegraph"><JqxGaugeK2O ref="GaugeK2O" :ranges="ranges" :ticksMinor="ticksMinor"
                :ticksMajor="ticksMajor" :value="balance.K2O.nutrient_balance" :cap="cap" :pointer="pointer" :caption="caption"
                :colorScheme="'scheme05'" :animationDuration="1200" :min="min" :max="max" :labels="labels" :ticksDistance="ticksDistance"
                :radius="radius" :width="width" :height="height" :border="border" style="margin:auto">
                </JqxGaugeK2O>
                <div style="margin:3px;font-size:13px;">K<sub>2</sub>O : {{ balance.K2O.conclusion_text }}</div>
              </div>
              <div class="col4 lignegraph"><JqxGaugeMgO ref="GaugeMgO" :ranges="ranges" :ticksMinor="ticksMinor"
                :ticksMajor="ticksMajor" :value="balance.MgO.nutrient_balance" :cap="cap" :pointer="pointer" :caption="caption"
                :colorScheme="'scheme05'" :animationDuration="1200" :min="min" :max="max" :labels="labels" :ticksDistance="ticksDistance"
                :radius="radius" :width="width" :height="height" :border="border" style="margin:auto">
                </JqxGaugeMgO>
                <div style="margin:3px;font-size:13px;">MgO : {{ balance.MgO.conclusion_text }}</div>
              </div>
        </div>

        <div class="saisie" style="padding-top:25px;margin-bottom:50px;border-top: 1px dashed rgb(204, 0, 0);">
          <div style="text-align:left;">{{ $t('libelle_apports') }} : <img src="../assets/info2.jpg" style="width:20px;vertical-align:middle;" v-tooltip.right-start="{content: getTextTooltip('tooltip_apports'), trigger: 'hover click', classes: 'tooltip'}" :open-on-hover="true" /></div>
          <div>
              <div class="col1">N : <b>{{balance.NtotBilan.nutrient_from_fertiliser}}</b> <span style="font-size:0.7em;">{{this.organic_fertiliser_unit}}/ha</span></div>
              <div class="col2">P<sub>2</sub>O<sub>5</sub> : <b>{{balance.P2O5.nutrient_from_fertiliser}}</b> <span style="font-size:0.7em;">{{this.organic_fertiliser_unit}}/ha</span></div>
              <div class="col3">K<sub>2</sub>O : <b>{{balance.K2O.nutrient_from_fertiliser}}</b> <span style="font-size:0.7em;">{{this.organic_fertiliser_unit}}/ha</span></div>
              <div class="col4">MgO : <b>{{balance.MgO.nutrient_from_fertiliser}}</b> <span style="font-size:0.7em;">{{this.organic_fertiliser_unit}}/ha</span></div>
          </div>
        </div>


        <div style="position: relative;width: 70%;margin: auto;margin-bottom: 20px;padding-top:25px;border-top: 1px dashed rgb(204, 0, 0);">
          {{ $t('titre_graphique') }}
          <img src="../assets/info2.jpg" style="width:20px;vertical-align:middle;margin-left:10px;" v-tooltip.right-start="{content: getTextTooltip('tooltip_graphique'), trigger: 'hover click', classes: 'tooltip'}" :open-on-hover="true" />  
        </div>
        <div style="position: relative;width: 70%;margin: auto; margin-bottom: 40px;">
          <img :src="getImgUrl('graph_'+this.$i18n.locale+'.jpg')" @load="setheight" alt="Logo ARVALIS - Institut du végétal" style="width:100%;" />
          <div class="marker" :style="btnStyles"></div>
        </div>
        
      </div>

    </div>


  </div>
</template>

<script>
import JqxGaugeN from 'jqwidgets-scripts/jqwidgets-vue/vue_jqxgauge.vue';
import JqxGaugeP2O5 from 'jqwidgets-scripts/jqwidgets-vue/vue_jqxgauge.vue';
import JqxGaugeK2O from 'jqwidgets-scripts/jqwidgets-vue/vue_jqxgauge.vue';
import JqxGaugeMgO from 'jqwidgets-scripts/jqwidgets-vue/vue_jqxgauge.vue';
import axios from 'axios';
import Vue from 'vue';
import VueNumberInput from '@chenfengyuan/vue-number-input';
Vue.component('number-input', VueNumberInput);


// import ECharts modules manually to reduce bundle size
import 'echarts/lib/component/tooltip'
import 'echarts/lib/chart/gauge'

// register component to use

import urlImage1 from '../assets/graph.jpg'

export default {
  name: 'InterfaceCalcul',
  data() {

    let data = []

    for (let i = 0; i <= 360; i++) {
        let t = i / 180 * Math.PI
        let r = Math.sin(2 * t) * Math.cos(2 * t)
        data.push([r, i])
    }

    return {
      baseUrl: process.env.VUE_APP_BASE_URL,
      data: [],
      imageHeight: 0,
      imageWidth: 0,
      bottom: 0,
      left:0,
      urlImage: urlImage1,
      markers:[{id:1,x:0.2,y:0.1}],
      etape: 1,
      bouton_1: 'active',
      bouton_2: '',
      bouton_3: '',
      imageLink_tete: '../assets/tete_AA01.jpg',
      application_methods: [],
      errors_am: [],
      organic_fertilisers: [],
      organic_fertiliser_unit: "",
      errors_of: [],
      feeding_periods: [],
      errors_fp: [],
      sowing_periods: [],
      errors_sp: [],
      nutrient_content_ini: [],
      nutrient_content: [],
      errors_nc: [],
      errors_nb: [],
      liste_periodes_implantation: '',
      liste_produits_organiques: '',
      liste_periodes_apport: '',
      liste_techniques_epandage: '',
      advice : [],
      dose : 0,
      boutonBesoins : 'plus',
      boutonApportM : 'plus',
      balance : [],
      scheduled : {'N':0,'P2O5':0,'K2O':0,'MgO':0},
      mineral : {'N':0,'P2O5':0,'K2O':0,'MgO':0},
      ticksMinor: { interval: 50, size: '4%' },
      ticksMajor: { interval: 100, size: '12%' },
      min: -300,
      max: 300,
      radius:60,
      width:120,
      height:120,
      ranges: [
          { startValue: -300, endValue: -100, style: { fill: '#ff0000', stroke: '#ff0000' }, endWidth: 7, startWidth: 7 },
          { startValue: -100, endValue: -50, style: { fill: '#ff8000', stroke: '#ff8000' }, endWidth: 7, startWidth: 7 },
          { startValue: -50, endValue: -20, style: { fill: '#ffab00', stroke: '#ffab00' }, endWidth: 7, startWidth: 7 },
          { startValue: -20, endValue: 20, style: { fill: '#32CD32', stroke: '#32CD32' }, endWidth: 7, startWidth: 7 },
          { startValue: 20, endValue: 50, style: { fill: '#ffab00', stroke: '#ffab00' }, endWidth: 7, startWidth: 7 },
          { startValue: 50, endValue: 100, style: { fill: '#ff8000', stroke: '#ff8000' }, endWidth: 7, startWidth: 7 },
          { startValue: 100, endValue: 300, style: { fill: '#ff0000', stroke: '#ff0000' }, endWidth: 7, startWidth: 7 }
      ],
      border:  { visible: false},
      labels: {
                    //visible: false,
                    interval: 150,
                    //position: 'outside',
                    distance: '27px'
                },
      ticksDistance: '10px',
      cap: { size: '5%', style: { fill: '#000000', stroke: '#000000' } , visible: true },
      pointer: { pointerType: 'default', style: { fill: '#000000', stroke: '#000000' }, length: '80%', width: '3%', visible: true },
      caption: { value: '0', position: 'bottom', offset: [0, 10], visible: true },


    }
  },
  components:{
    JqxGaugeN,
    JqxGaugeP2O5,
    JqxGaugeK2O,
    JqxGaugeMgO,
  },

  // Fetches posts when the component is created.
  created(){
    /*axios.get(this.baseUrl +`/list/application_methods`,{
            params: {
              lang: this.$i18n.locale
            }
          })*/
    axios.get(process.env.VUE_APP_APPEL_API_AJAX+`?method=application_methods`,{
            params: {
              lang: this.$i18n.locale
            }
          })
    .then(response => {
      // JSON responses are automatically parsed.
      var rep_application_methods = response.data
      this.application_methods = rep_application_methods.applicationmethods
      this.errors_am = [];
    })
    .catch(e => {
      this.errors_am.push(e)
    })

    /*axios.get(this.baseUrl +`/fertilisers/organic`,{
            params: {
              lang: this.$i18n.locale
            }
    })*/
    axios.get(process.env.VUE_APP_APPEL_API_AJAX+`?method=organic`,{
            params: {
              lang: this.$i18n.locale
            }
          })
    .then(response => {
      // JSON responses are automatically parsed.
      var rep_organic_fertilisers = response.data
      this.organic_fertilisers = rep_organic_fertilisers.fertilisers
      this.errors_of = [];
    })
    .catch(e => {
      this.errors_of.push(e)
    })

    /*axios.get(this.baseUrl +`/list/feeding_periods`,{
            params: {
              lang: this.$i18n.locale
            }
          })*/
    axios.get(process.env.VUE_APP_APPEL_API_AJAX+`?method=feeding_periods`,{
        params: {
          lang: this.$i18n.locale
        }
      })
    .then(response => {
      // JSON responses are automatically parsed.
      var rep_feeding_periods = response.data
      this.feeding_periods = rep_feeding_periods.feedingperiods
      this.errors_fp = [];
    })
    .catch(e => {
      this.errors_fp.push(e)
    })

    /*axios.get(this.baseUrl +`/list/sowing_periods`,{
            params: {
              lang: this.$i18n.locale
            }
          })*/
    axios.get(process.env.VUE_APP_APPEL_API_AJAX+`?method=sowing_periods`,{
        params: {
          lang: this.$i18n.locale
        }
      })
    .then(response => {
      // JSON responses are automatically parsed.
      var rep_sowing_periods = response.data
      this.sowing_periods = rep_sowing_periods.sowingperiods
      this.errors_sp = [];
    })
    .catch(e => {
      this.errors_sp.push(e)
    })


  },

  methods:{
    setheight(event) {
      let image = event.target;
      this.imageHeight = image.clientHeight;
      this.imageWidth = image.clientWidth;


      if(this.liste_produits_organiques.id!=undefined){
        /*axios.get(this.baseUrl +`/fertilisers/organic/`+this.liste_produits_organiques.id+`/graphic_position`,{
            params: {
              lang: this.$i18n.locale,
              nutrient_content_corr: JSON.stringify([{"nutrient_code":"Ntot","value":this.nutrient_content["Ntot"]},
                                        {"nutrient_code":"N-NH4","value":this.nutrient_content["N-NH4"]},
                                        {"nutrient_code":"Corg","value":this.nutrient_content["Corg"]}])
            }
          })*/
        axios.get(process.env.VUE_APP_APPEL_API_AJAX+`?method=graphic_position`,{
          params: {
              lang: this.$i18n.locale,
              nutrient_content_corr: JSON.stringify([{"nutrient_code":"Ntot","value":this.nutrient_content["Ntot"]},
                                        {"nutrient_code":"N-NH4","value":this.nutrient_content["N-NH4"]},
                                        {"nutrient_code":"Corg","value":this.nutrient_content["Corg"]}]),
              id_ferti:this.liste_produits_organiques.id
            }
        })
        .then(response => {
          var positions = response.data.graphicpositions[0]

          var valeur_orga = positions.x_axes; //a recuperer selon valeur calculée
          var valeur_nutri = positions.y_axes; //a recuperer selon valeur calculée

          var val_max_abscisse = 200; //prendre en compte le fait que l'image va au delà de la fin de l'axe (mette plus que le max)
          var val_max_ordonnee = 113; //prendre en compte le fait que l'image va au delà de la fin de l'axe (mette plus que le max)

          //decalage du au fait que le point (0;0) ne soit pas en bas à gauche de l'image
          var decalage_abscisse = this.imageWidth*7.6/100
          var decalage_ordonnee = this.imageHeight*12.5/100

          //calcul de la position sur l'image
          this.bottom = decalage_ordonnee + (valeur_nutri*(this.imageHeight-decalage_ordonnee))/val_max_ordonnee;
          this.left = decalage_abscisse + (valeur_orga*(this.imageWidth-decalage_abscisse))/val_max_abscisse;
        })
      }

    },
    getImgUrl(code_tete) {
      return require('../assets/'+code_tete)
    },
    getTextTooltip:function(nom_variable){
      //return $t(nom_variable)
      return this.$t(nom_variable)
    },
    switchB:function(type){
      var tabChange = {'plus' : 'moins', 'moins' : 'plus'}
      if(type=='besoins'){
        this.boutonBesoins = tabChange[this.boutonBesoins]
      } else if(type=='apports'){
        this.boutonApportM = tabChange[this.boutonApportM]
      }
    },
    AgronomicalAdvice:function(){
      if(this.liste_produits_organiques.id!=undefined && this.liste_periodes_apport.id!=undefined && this.liste_periodes_implantation.id!=undefined){
        /*axios.get(this.baseUrl +`/fertilisers/organic/`+this.liste_produits_organiques.id+`/agronomical_advice`,{
            params: {
              lang: this.$i18n.locale,
              txt_sowing_period: this.liste_periodes_implantation.id,
              txt_feeding_period: this.liste_periodes_apport.id
            }
          })*/
        axios.get(process.env.VUE_APP_APPEL_API_AJAX+`?method=agronomical_advice`,{
          params: {
              lang: this.$i18n.locale,
              txt_sowing_period: this.liste_periodes_implantation.id,
              txt_feeding_period: this.liste_periodes_apport.id,
              id_ferti:this.liste_produits_organiques.id
            }
        })
        .then(response => {
          // JSON responses are automatically parsed.
          var advice = response.data
          this.advice = advice.agronomicaladvices[0]
        })
      }
    },
    RetrieveContent:function(){
      /*axios.get(this.baseUrl +`/fertilisers/organic/`+this.liste_produits_organiques.id+`/nutrient_content`,{
            params: {
              lang: this.$i18n.locale
            }
      })*/
      axios.get(process.env.VUE_APP_APPEL_API_AJAX+`?method=nutrient_content`,{
        params: {
          lang: this.$i18n.locale,
          id_ferti: this.liste_produits_organiques.id
        }
      })
      .then(response => {
        // JSON responses are automatically parsed.
        var rep_nutrient_content_ini = response.data
        this.nutrient_content_ini = rep_nutrient_content_ini.nutrientcontents

        var i= 0
        var tab = []
        for(i = 0; i < this.nutrient_content_ini.length; i++){
          tab[this.nutrient_content_ini[i].nutrient_code] = this.nutrient_content_ini[i].value
        }
        this.nutrient_content = {'Ntot': tab['Ntot'], 'N-NH4': tab['N-NH4'], 'P2O5': tab['P2O5'], 'K2O': tab['K2O'], 'MgO': tab['MgO'], 'Corg': tab['Corg']}
       
        var j= 0;
        for(j = 0; j < this.organic_fertilisers.length; j++){
          if(this.organic_fertilisers[j].id == this.liste_produits_organiques.id){
            this.organic_fertiliser_unit = this.organic_fertilisers[j].unit
          }
        }

        this.errors_nc = [];

      })
      .catch(e => {
        this.errors_nc.push(e)
      }),
      this.AgronomicalAdvice();
    },
    ValueNutrient:function(idx) {
      var i= 0;
      for(i = 0; i < this.nutrient_content.length; i++){
        if(this.nutrient_content[i].nutrient_code == idx){
          return this.nutrient_content[i].value
        }
      }
    },
    SetValueNutrient:function(idx) {
      var i= 0;
      for(i = 0; i < this.nutrient_content.length; i++){
        if(this.nutrient_content[i].nutrient_code == idx){
          this.nutrient_content[i].value = this.qte_+'idx'
        }
      }
    },
    Bilan:function(){
      this.errors_nb = [];
      if(this.liste_produits_organiques.id!=undefined && this.liste_periodes_apport.id!=undefined && this.liste_periodes_implantation.id!=undefined){
        /*axios.get(this.baseUrl +`/fertilisers/organic/`+this.liste_produits_organiques.id+`/nutrient_balance`,{
            params: {
              lang: this.$i18n.locale,
              txt_sowing_period: this.liste_periodes_implantation.id,
              txt_feeding_period: this.liste_periodes_apport.id,
              txt_application_method: this.liste_techniques_epandage.id,
              fertiliser_amount: this.dose,
              scheduled_fertilisation: JSON.stringify([{"nutrient_code":"Ntot","value":this.scheduled.N},
                                        {"nutrient_code":"P2O5","value":this.scheduled.P2O5},
                                        {"nutrient_code":"K2O","value":this.scheduled.K2O},
                                        {"nutrient_code":"MgO","value":this.scheduled.MgO}]),
              mineral_fertilisation: JSON.stringify([{"nutrient_code":"Ntot","value":this.mineral.N},
                                        {"nutrient_code":"P2O5","value":this.mineral.P2O5},
                                        {"nutrient_code":"K2O","value":this.mineral.K2O},
                                        {"nutrient_code":"MgO","value":this.mineral.MgO}]),
              nutrient_content_corr: JSON.stringify([{"nutrient_code":"Ntot","value":this.nutrient_content.Ntot},
                                        {"nutrient_code":"P2O5","value":this.nutrient_content.P2O5},
                                        {"nutrient_code":"K2O","value":this.nutrient_content.K2O},
                                        {"nutrient_code":"MgO","value":this.nutrient_content.MgO}])
            }
          })*/
        axios.get(process.env.VUE_APP_APPEL_API_AJAX+`?method=nutrient_balance`,{
          params: {
              lang: this.$i18n.locale,
              txt_sowing_period: this.liste_periodes_implantation.id,
              txt_feeding_period: this.liste_periodes_apport.id,
              txt_application_method: this.liste_techniques_epandage.id,
              fertiliser_amount: this.dose,
              scheduled_fertilisation: JSON.stringify([{"nutrient_code":"Ntot","value":this.scheduled.N},
                                        {"nutrient_code":"P2O5","value":this.scheduled.P2O5},
                                        {"nutrient_code":"K2O","value":this.scheduled.K2O},
                                        {"nutrient_code":"MgO","value":this.scheduled.MgO}]),
              mineral_fertilisation: JSON.stringify([{"nutrient_code":"Ntot","value":this.mineral.N},
                                        {"nutrient_code":"P2O5","value":this.mineral.P2O5},
                                        {"nutrient_code":"K2O","value":this.mineral.K2O},
                                        {"nutrient_code":"MgO","value":this.mineral.MgO}]),
              nutrient_content_corr: JSON.stringify([{"nutrient_code":"Ntot","value":this.nutrient_content.Ntot},
                                        {"nutrient_code":"P2O5","value":this.nutrient_content.P2O5},
                                        {"nutrient_code":"K2O","value":this.nutrient_content.K2O},
                                        {"nutrient_code":"MgO","value":this.nutrient_content.MgO}]),
              id_ferti: this.liste_produits_organiques.id
            }
        })
        .then(response => {
          var nutrient_balance = response.data

          //verifie presence message erreur
          if(nutrient_balance.messages){
            for (var k = 0; k < nutrient_balance.messages.length; k++) {
              if(nutrient_balance.messages[k].Type == 'Error'){
                throw new TypeError(nutrient_balance.messages[k].Description)
              }
            }
          }

          this.nutrient_balance = nutrient_balance.nutrientbalances
          
          // JSON responses are automatically parsed.
          var i= 0;
          var o = new Object();
          for(i = 0; i < this.nutrient_balance.length; i++){
            var nom_elem = this.nutrient_balance[i].nutrient_code;
            if(nom_elem == 'Ntot'){
              nom_elem = this.nutrient_balance[i].nutrient_code+this.nutrient_balance[i].nutrient_type;
            }

            //pour gérer le fait que des valeurs puissent être null pour nutrient_from_fertiliser (et donc la fonction toFixed ne fonctionne pas)
            var nutrient_from_fertiliser = "-"
            if(this.nutrient_balance[i].nutrient_from_fertiliser !== null){
               nutrient_from_fertiliser = parseFloat(this.nutrient_balance[i].nutrient_from_fertiliser.toFixed(2))
            }
           
            o[nom_elem] = {"fertilising_effect":parseFloat(this.nutrient_balance[i].fertilising_effect.toFixed(2)),
                                                    "nutrient_from_fertiliser": nutrient_from_fertiliser,
                                                    "nutrient_balance":parseFloat(this.nutrient_balance[i].nutrient_balance.toFixed(2)),
                                                    "conclusion_code":this.nutrient_balance[i].conclusion_code,
                                                    "conclusion_text":this.nutrient_balance[i].conclusion_text};

          }

          this.balance = o

          if(this.etape == 3){
            this.$refs.GaugeN.caption = { value: this.balance.NtotBilan.nutrient_balance.toString(), position: 'bottom', offset: [0, 10], visible: true }
            this.$refs.GaugeN.value = this.balance.NtotBilan.nutrient_balance
                    
            this.$refs.GaugeP2O5.caption = { value: this.balance.P2O5.nutrient_balance.toString(), position: 'bottom', offset: [0, 10], visible: true }
            this.$refs.GaugeP2O5.value = this.balance.P2O5.nutrient_balance
            
            this.$refs.GaugeK2O.caption = { value: this.balance.K2O.nutrient_balance.toString(), position: 'bottom', offset: [0, 10], visible: true }
            this.$refs.GaugeK2O.value = this.balance.K2O.nutrient_balance

            this.$refs.GaugeMgO.caption = { value: this.balance.MgO.nutrient_balance.toString(), position: 'bottom', offset: [0, 10], visible: true }
            this.$refs.GaugeMgO.value = this.balance.MgO.nutrient_balance
          }

          this.errors_nb = [];
          /*setTimeout(function(){
            this.$refs.GaugeN.value = this.balance.Ntot.nutrient_balance
            //this.$refs.GaugeN.caption = { value: this.balance.Ntot.nutrient_balance, position: 'bottom', offset: [0, 10], visible: true }
            this.$refs.GaugeP2O5.value = this.balance.P2O5.nutrient_balance
            //this.$refs.GaugeP2O5.caption = { value: this.balance.P2O5.nutrient_balance, position: 'bottom', offset: [0, 10], visible: true }
            this.$refs.GaugeK2O.value = this.balance.K2O.nutrient_balance
            //this.$refs.GaugeK2O.caption = { value: this.balance.K2O.nutrient_balance, position: 'bottom', offset: [0, 10], visible: true }
            this.$refs.GaugeMgO.value = this.balance.MgO.nutrient_balance
            //this.$refs.GaugeMgO.caption = { value: this.balance.MgO.nutrient_balance, position: 'bottom', offset: [0, 10], visible: true }
          }, 10000)*/
        })
        .catch(e => {
          this.errors_nb.push(e)
        })
      }
    },
    setEtape:function(i){
      if(i==3){
        this.Bilan()
      }

      if(i==2 || i==3){
        if(this.liste_produits_organiques.id!=undefined && this.liste_periodes_apport.id!=undefined && this.liste_periodes_implantation.id!=undefined && this.liste_techniques_epandage.id!=undefined && isNaN(this.nutrient_content['Ntot'])==false && isNaN(this.nutrient_content['N-NH4'])==false && isNaN(this.nutrient_content['P2O5'])==false && isNaN(this.nutrient_content['K2O'])==false && isNaN(this.nutrient_content['MgO'])==false && isNaN(this.nutrient_content['Corg'])==false){
          this.etape=i
        } else {
          alert (this.$t('alerte.etape1'))
        }
      } else {
        this.etape=i
      }

      //pour retour en haut de page au changement d'étape
      location.href='#app'

    }
  },
  computed: {
    btnStyles() {
      return {
        "position":'absolute',
        "bottom":`${this.bottom}px`,
        "left":`${this.left}px`,
      };
    }
  }
}
</script>

<style>

</style>